import { Directive, HostListener } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RightPanelComponent } from '@shared/interactions';

@Directive({
    selector: '[matHorizontalStepperScroller]',
    standalone: false
})
export class MatHorizontalStepperScrollerDirective {
    public currentDialog: MatDialogRef<RightPanelComponent> | null | undefined = null;

    constructor(
        private dialog: MatDialog
    ) {}

    @HostListener('selectionChange', ['$event'])
    public selectionChanged(): void {
        if (this.dialog.openDialogs) {
            this.currentDialog = this.currentDialog ?? this.dialog.openDialogs.pop();

            if (this.currentDialog?.id) {
                const dialogElement = document.getElementById(this.currentDialog.id);

                if (dialogElement) {
                    const wrapper = dialogElement.getElementsByClassName('wrapper')[0];

                    wrapper.scrollTop = 0;
                }
            }
        }
    }
}
